import * as Styled from './OxLink.styled';

import React, { useContext } from 'react';
import { ThemedInputContext } from 'src/context/ThemedInputContext';
import { isPdfUrl } from 'src/utils/isPdfUrl';

// Since DOM elements <a> cannot receive activeClassName
// and partiallyActive, destructure the prop here and
// pass it only to GatsbyLink
export const OxLink = ({
    children,
    to,
    activeClassName,
    partiallyActive,
    state,
    subItem,
    hideOnMobile,
    target,
    rel,
    withUnderlineAnimation,
    asButton,
    forceExternal,
    ...other
}: any): JSX.Element => {
    const themeContext = useContext(ThemedInputContext);
    const isPdf = isPdfUrl(to);
    const safeTarget = isPdf ? '_blank' : target;
    const safeRel = isPdf ? 'noopener noreferrer' : rel;

    if (asButton) {
        return (
            <Styled.Button
                $customTheme={themeContext}
                to={to}
                activeClassName={activeClassName || 'active'}
                partiallyActive={partiallyActive}
                state={state}
                $withUnderlineAnimation={withUnderlineAnimation}
                {...other}
            >
                {children}
            </Styled.Button>
        );
    }

    // Tailor the following test to your environment.
    // This example assumes that any internal link (intended for Gatsby)
    // will start with exactly one slash, and that anything else is external.
    const external = !/^\/(?!\/)/.test(to) || safeTarget || forceExternal || isPdf;
    // Use Gatsby Link for internal links, and <a> for others

    if (!external) {
        return (
            <Styled.GatsbyLink
                $customTheme={themeContext}
                to={to}
                activeClassName={activeClassName || 'active'}
                partiallyActive={partiallyActive}
                state={state}
                $withUnderlineAnimation={withUnderlineAnimation}
                {...other}
            >
                {children}
            </Styled.GatsbyLink>
        );
    }
    return (
        <Styled.RegularLink
            $customTheme={themeContext}
            href={to}
            target={safeTarget}
            rel={safeRel}
            $withUnderlineAnimation={withUnderlineAnimation}
            {...other}
        >
            {children}
        </Styled.RegularLink>
    );
};
